<template>
	<v-dialog
		v-model="ui.dialog"
		:width="$vuetify.breakpoint.smAndDown ? '100%' : '600px'"
	>
		<v-card :class="[$vuetify.breakpoint.smAndDown ? 'pa-2' : 'pa-4']">
			<v-card-title>
				Antes de continuar.
			</v-card-title>
			<v-card-text class="pt-0">
				<v-row>
					<v-col cols="12" class="pb-0 pt-0">
						<v-alert type="info" text prominent class="mb-0">
							Para poder continuar con tu pedido es nesesario
							iniciar sesíon primero.
						</v-alert>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions
				:class="[
					'd-flex',
					$vuetify.breakpoint.mdAndUp
						? 'justify-end'
						: 'flex-column-reverse',
				]"
			>
				<v-btn
					text
					color="primary"
					@click="redirectCreateAcount()"
					:large="$vuetify.breakpoint.smAndDown"
					:block="$vuetify.breakpoint.smAndDown"
				>
					crear cuenta
				</v-btn>

				<v-btn
					color="primary"
					@click="redirectLogin()"
					:large="$vuetify.breakpoint.smAndDown"
					:block="$vuetify.breakpoint.smAndDown"
					:class="[{ 'mb-3': $vuetify.breakpoint.smAndDown }]"
				>
					Iniciar sesión
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { EventBus } from "@/main";

export default {
	data() {
		return {
			ui: {
				dialog: false,
			},
		};
	},

	created() {
		EventBus.$on("LoginRequest", () => {
			this.ui.dialog = true;
		});
	},

	methods: {
		redirectCreateAcount() {
			this.ui.dialog = false;

			this.$router.push({ name: "Register" });
		},

		redirectLogin() {
			this.ui.dialog = false;

			this.$router.push({ name: "Login" });
		},
	},

	computed: {},
};
</script>

<style lang="css" scoped></style>
